import { Position } from '#src/__generated__/globalTypes.ts';
import { joinFiltersWithOr } from '#src/lib/algolia.ts';
import { StatsMode } from '#src/lib/playerSearchView.ts';

const PositionByStatsMode = {
  [StatsMode.HITTING]: [
    Position.baseball_outfield,
    Position.baseball_first_base,
    Position.baseball_second_base,
    Position.baseball_third_base,
    Position.baseball_shortstop,
    Position.baseball_designated_hitter,
    Position.baseball_catcher,
  ],
  [StatsMode.PITCHING]: [
    Position.baseball_starting_pitcher,
    Position.baseball_relief_pitcher,
  ],
  [StatsMode.DEFAULT]: [],
};

export const useStatsModeFilterValue = (statsMode: StatsMode | false) => {
  const statsModeFilterValue = (() => {
    return joinFiltersWithOr(
      PositionByStatsMode[statsMode || StatsMode.DEFAULT].map(
        p => `position:${p}`
      )
    );
  })();

  return statsModeFilterValue;
};
